import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = ({ImageError, Title, Description, LinkRedireccion, TextRedireccion}) => (
    <main className="page-not-found">
        <section className="container-error-404">

            <img className="image-error-404" src={ImageError} alt={Title} />

            <h1 className="title-error-404"> {Title} </h1>

            <p className="description-error-404"> {Description} <Link to={LinkRedireccion} > {TextRedireccion} </Link> </p>

        </section>
    </main>
)

export default Error404;
